module.exports = __webpack_public_path__ + "static/media/correct.8e3d6124.mp3";